(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TransactionAsyncTaskDialogController', TransactionAsyncTaskDialogController);

    TransactionAsyncTaskDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TransactionAsyncTask', 'Transaction'];

    function TransactionAsyncTaskDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TransactionAsyncTask, Transaction) {
        var vm = this;

        vm.transactionAsyncTask = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.transactions = Transaction.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.transactionAsyncTask.id !== null) {
                TransactionAsyncTask.update(vm.transactionAsyncTask, onSaveSuccess, onSaveError);
            } else {
                TransactionAsyncTask.save(vm.transactionAsyncTask, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:transactionAsyncTaskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.nextCheckDate = false;
        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
